module.exports = __webpack_public_path__ + "img/fist-raised.6038aa67.svg";